import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function InvitePage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login page with state indicating this is an invitation flow
    // The invitation is validated on the backend using (tenant_id from subdomain, email from Google OAuth)
    navigate('/login', { replace: true, state: { fromInvite: true } });
  }, [navigate]);

  // Show loading while redirecting
  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-muted-foreground">Processing invitation...</p>
    </div>
  );
}
